import { Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/img/artic-logo.svg';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  menuButton: {
    marginRight: '2em',
  },
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  spacer: {
    flex: 1,
  },
  logo: {
    height: '45px',
    width: '145px',
  },
  logoContainer: {
    height: '45px',
    width: '145px',
    marginBottom: 5,
    marginTop: 5,
  },
  appbar: {
    color: '#737373',
    backgroundColor: '#ffffff',
    display: 'block',
    position: 'relative',
  },
});

export default function AppBarOnly() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appbar}>
        <Toolbar variant="dense">
          <Typography
            variant="h6"
            color="inherit"
            className={classes.title}
            id="react-admin-title"
          />
          <Link to="/" className={classes.logoContainer}>
            <img src={logo} alt="logo" className={classes.logo} />
          </Link>
          <span className={classes.spacer} />
        </Toolbar>
      </AppBar>
    </div>
  );
}
